import { TypesOfShippings } from './types';

export const DEFAULT_SHIPPING_OPTION_NAMES: Record<TypesOfShippings, string> = {
  [TypesOfShippings.IN_PLACE]: 'Consumo en local',
  [TypesOfShippings.TAKE_AWAY]: 'Retiro en persona',
  [TypesOfShippings.DELIVERY]: 'Envío a domicilio - Delivery',
  [TypesOfShippings.PARCEL]: 'Envío a domicilio - Paquetería',
};
